import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import removeProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import { FacetModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import CENCustomCategoriesFilterHandler from "@tCentro/Handlers/CENCustomCategoriesFilterHandler";
import CustomApplicationState from "@tCentro/Store/CustomApplicationState";
import NISProductListFiltersAccordionSection from "@tCentro/Widgets/ProductList/NISProductListFilterAccordionSection";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { useDispatch } from "react-redux";

const enum fields {
    expandByDefault = "expandByDefault",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.expandByDefault]: boolean;
    };
}

const mapStateToProps = (state: CustomApplicationState) => {
    const attributeFilteredData = state.t_components?.attributeNames?.mainData;
    return {
        categoryFacets: getProductListDataViewProperty(state, "categoryFacets"),
        isCategoryPage: state.pages.productList.productFilters.pageCategoryId !== undefined,
        attributeFilteredData
    };
};

const mapDispatchToProps = {
    addProductFilters,
    removeProductFilters,
    CENCustomCategoriesFilterHandler,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export const productListCategoryFiltersStyles: ProductListFilterAccordionSectionStyles = {};

const ProductListCategoryFilters: FC<Props> = ({
    categoryFacets,
    isCategoryPage,
    addProductFilters,
    removeProductFilters,
    fields,
    attributeFilteredData,
    CENCustomCategoriesFilterHandler,
}) => {

    // TODO ISC-11787 - make showMoreLimit configurable
    const showMoreLimit = 10;
    const [mainFacetData, setMainFacetData] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        if (attributeFilteredData.length) {
            setMainFacetData(attributeFilteredData.includes("Categories"));
        }

        return () => {
            dispatch({ type: "Custom/ProductList/CategoriesFilter/SetInitialValues" });
        };
    }, [attributeFilteredData]);
    
    if (isCategoryPage || !categoryFacets?.length) {
        return null;
    }

    const facets = categoryFacets?.map(o => ({
        ...o,
        id: o.categoryId,
        name: o.shortDescription,
    }));

  

    const onChangeFacet = (facet: FacetModel) => {
        if (facet.selected) {
            removeProductFilters({ categoryId: facet.id });
            CENCustomCategoriesFilterHandler({isIncludeSubCategoriesFlag:true})
        } else {
            addProductFilters({ categoryId: facet.id });
            CENCustomCategoriesFilterHandler({isIncludeSubCategoriesFlag:false})
        }
    };

    return (
        <>
            {mainFacetData && (
                <NISProductListFiltersAccordionSection
                    title={translate("Categories")}
                    facets={facets}
                    onChangeFacet={onChangeFacet}
                    showMoreLimit={showMoreLimit}
                    expandByDefault={fields.expandByDefault}
                    extendedStyles={productListCategoryFiltersStyles}
                />
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListCategoryFilters),
    definition: {
        group: "Product List",
        displayName: "NIS Category Filters",
        allowedContexts: ["ProductListPage"],
        fieldDefinitions: [
            {
                name: fields.expandByDefault,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
